import React, { useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import ModalHeader from "../../../Setup/Shared/ModalHeader"
import ModalFooter from '../../../Setup/Shared/ModalFooter';
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList";
import { enumUtil } from '../../../../utils/Enum';
import { isNull } from 'lodash';

const MergePatient = ({mergeEvent, onClose}) => {

    let Merge_Modal = {
        FirstPatient:'',
        SecondPatient:'',
    }
    const API_URl = enumUtil.controller.Claim;
    const [mainMergePatientModal, setMainMergePatientModal] = useState(Merge_Modal);
    const [saveMergePatientModal, setSaveMergePatientModal] = useState({});
    const [patientBody, setPatientBody] = useState({"TableName": '', "SearchParam": ''});
    const [patientName, setPatientName] = useState(null);
    const [is, setIs] = useState(null)
    //////////////////// Patient Search and Select Patient
    const handlePateintChange = (e) => {
        setIs(false);
        let modal = {...mainMergePatientModal};
        let saveModal = {...saveMergePatientModal};
        let { name, value } = e.target;
        modal[name] = value;
        setPatientName(value);
        setMainMergePatientModal(modal);
        for(let property in modal){
            if(property === name){
                saveModal[name] = value
            }
        }
        setSaveMergePatientModal(saveModal)


        // let modal = { ...mainAppointmentModal };
        // modal[name] = value;
        // setMainAppointmentModal(modal)
        setPatientBody({ "TableName": enumUtil.enumAPITableName.Patient, "SearchParam": value })
    }
    
    const  handleSelectedData = (selectedData, name, type) => {
        console.log('+++',selectedData,name)
        let modal = {...mainMergePatientModal};
        let saveModal = {...saveMergePatientModal};
        if(!isNull(selectedData)){
            modal[name] = selectedData?.display;
            saveModal[name] = selectedData?.value
        }
        setMainMergePatientModal(modal)
        setSaveMergePatientModal(saveModal)
        console.log('...',mainMergePatientModal,saveMergePatientModal)
    }
    const Pateint = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '14px', fontWeight: '600', margin: 'auto' }}>Merge Patients</p>;
    };

    return (
        <div>
            <Modal show={mergeEvent} onHide={mergeEvent} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 add_merge_patient">
                <Modal.Body>
                    <ModalHeader HeaderName={Pateint} DeletePopup={""} isClosed={onClose} key={631} Name={'MergePatient'} />

                    <div className='mb-2'>
                        <p className='text'>Merge Duplicate Accounts</p>
                    </div>
                    <div className='d-flex gap-3 mb-3'>
                        <div className='w-100'>
                            <SuperSearchList
                                type='server'
                                id='FirstPatient'
                                name='FirstPatient'
                                method='post'
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                onChange={handlePateintChange}
                                // value={mainMergePatientModal.FirstPatient}
                                icon={true}
                                searchValue={mainMergePatientModal.FirstPatient}
                                ApiLink={API_URl + "/PatientInstantSearch"}
                                postBody={patientBody}
                                getSelectedData={handleSelectedData}
                                is={is}
                                // disabled={true}
                                placeholder={false}
                                autocomplete={false}
                            />
                        </div>
                        <div className='ar-info d-flex justify-content-center align-items-center'>
                            <p className='heading'>Info</p>
                        </div>
                    </div>
                    <div className='d-flex gap-3 mb-2'>
                        <div className='w-100'>
                            <SuperSearchList
                                type='server'
                                id='SecondPatient'
                                name='SecondPatient'
                                method='post'
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                onChange={handlePateintChange}
                                value={mainMergePatientModal.SecondPatient}
                                icon={true}
                                searchValue={mainMergePatientModal.SecondPatient}
                                ApiLink={API_URl + "/PatientInstantSearch"}
                                postBody={patientBody}
                                getSelectedData={handleSelectedData}
                                is={is}
                                // disabled={true}
                                placeholder={false}
                                autocomplete={false}
                            />
                        </div>
                        <div className='ar-info d-flex justify-content-center align-items-center'>
                            <p className='heading'>Info</p>
                        </div>
                    </div>
                    <div className='mb-2'>
                        <p className='text xsm_text text-danger'>This cannot be undone. Please make sure you are merging only duplicate accounts!</p>
                    </div>
                </Modal.Body>
                <ModalFooter isSaved={onClose}/>
            </Modal>
        </div>
    )
}

export default MergePatient
